module.exports = __webpack_public_path__ + "img/secure_remote_sessions.4296cb58.png";